import type { AnalyticsQuery } from "schemas/generated/analyticsRead";

import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import useAnalyticsStatus from "@v2/features/analytics/hooks/useAnalyticsStatus";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { analyticsRouter } from "@v2/trpc/routes/analytics";

export type UrlHostsObj = {
  data: AnalyticsQuery["urlHosts"];
  isLoading: boolean;
};

const useUrlHosts = (): UrlHostsObj => {
  const workspaceId = useCurrentWorkspaceId() ?? undefined;
  const projectId = useCurrentProjectId();

  const { isEnabled, isLoading: isLoadingAnalyticsStatus } =
    useAnalyticsStatus();

  const shouldFetch = isEnabled && Boolean(workspaceId || projectId);

  const { data, isLoading: isLoadingUrlHosts } =
    analyticsRouter.getUrlHostsWithSubDomains.useQuery(
      { workspaceId: workspaceId!, projectId: projectId! },
      { enabled: shouldFetch },
    );

  const sortedDataRootDomainsFirst = data?.sort((hostA, hostB) => {
    return (hostB.isRootDomain ? 1 : 0) - (hostA.isRootDomain ? 1 : 0);
  });

  return {
    data: sortedDataRootDomainsFirst?.map((host) => host.urlHost) ?? [],
    isLoading: isLoadingAnalyticsStatus || isLoadingUrlHosts,
  };
};

export default useUrlHosts;
